{
  "actions": {
    "back": "رجوع"
  },
  "till": {
    "title": "نقطة البيع",
    "till": "الصندوق",
    "shift": "الوردية",
    "cashier": "الكاشير",
    "backOffice": "الإدارة",
    "loading": "جارٍ تحميل شاشة البيع…",
    "saleArea": "البيع",
    "summary": "ملخص البيع"
  },
  "menu": {
    "label": "قائمة الصندوق",
    "sales": "مبيعات هذه الوردية",
    "return": "إرجاع بضاعة",
    "cashMovement": "إيداع / سحب نقدي",
    "xReport": "تقرير X",
    "clear": "مسح البيع",
    "switchShift": "تبديل الوردية",
    "closeShift": "إغلاق الوردية"
  },
  "open": {
    "title": "فتح وردية",
    "body": "اختر الصندوق الذي تعمل عليه وعُدّ النقد الموجود في درجه.",
    "till": "الصندوق",
    "cashAndCard": "نقدًا وبطاقة",
    "cashOnly": "نقدًا فقط",
    "float": "النقد المعدود في الدرج",
    "floatHint": "عُدّه الآن. إذا اختلف عما تُظهره الدفاتر للدرج، يُسجَّل الفرق زيادةً أو عجزًا في النقد.",
    "submit": "فتح الوردية",
    "noTills": "لم يُعدّ أي صندوق بعد",
    "noTillsManage": "أضف صندوقًا بمستودعه ودرجه لتبدأ البيع.",
    "noTillsAsk": "اطلب من المدير إعداد صندوق من الإدارة.",
    "setUp": "إعداد الصناديق",
    "inUse": "قيد الاستخدام",
    "inUseHint": "توجد وردية مفتوحة على هذا الصندوق، ويجب إغلاقها قبل فتح وردية أخرى."
  },
  "choose": {
    "title": "اختر الوردية",
    "body": "لديك ورديات مفتوحة على أكثر من صندوق. اختر الوردية التي تبيع عليها.",
    "named": "البيع على الصندوق {{till}}، الوردية {{number}}"
  },
  "scan": {
    "label": "الباركود أو رمز الصنف أو الاسم أو الوصف",
    "placeholder": "امسح، أو اكتب الاسم أو رمز الصنف أو الباركود أو الوصف",
    "hint": "تظهر الأصناف المطابقة أثناء الكتابة؛ يضيف Enter الصنف المحدد أو الصنف الممسوح. اكتب 3*الرمز لإضافة ثلاث قطع. والحقل فارغ: + و− تغيّران كمية السطر المحدد، وDelete تحذفه، و↑ و↓ تنقلان بين السطور.",
    "looking": "جارٍ البحث…",
    "notFound": "لا يوجد صنف يطابق «{{code}}». تحقّق من الرمز أو ابحث بالاسم.",
    "noMatches": "لا يوجد صنف يطابق «{{query}}».",
    "matches": "نتائج «{{query}}»",
    "matchesLabel": "الأصناف المطابقة",
    "matchesHint": "↑ ↓ للاختيار، وEnter للإضافة، وEsc للإغلاق"
  },
  "cart": {
    "label": "أصناف هذا البيع",
    "empty": "امسح أول صنف",
    "emptyBody": "امسح الباركود، أو اكتب رمز الصنف أو اسمه واضغط Enter.",
    "keyAdd": "إضافة الصنف",
    "shortcuts": "اختصارات لوحة المفاتيح",
    "item": "الصنف",
    "quantity": "الكمية",
    "discount": "الخصم",
    "total": "الإجمالي",
    "actions": "إجراءات السطر",
    "less": "قطعة أقل من {{name}}",
    "more": "قطعة أخرى من {{name}}",
    "quantityOf": "كمية {{name}}",
    "unitOf": "وحدة {{name}}",
    "edit": "تعديل سعر {{name}} أو خصمه",
    "remove": "حذف {{name}}",
    "priceChanged": "سعر معدّل (سعر الكتالوج {{price}})",
    "keys": "+ / − لتغيير كمية السطر المحدد، وDelete لحذفه، و↑ ↓ للتحديد."
  },
  "lines": {
    "quantity": "الكمية",
    "wholeUnits": "وحدات كاملة فقط",
    "serialQuantity": "وحدة لكل رقم تسلسلي: غيّر الأرقام التسلسلية من السطر (ر.ت).",
    "price": "سعر الوحدة",
    "priceInclusive": "سعر الوحدة (شامل الضريبة)",
    "overrideHint": "غيّره فقط إذا كان سعر الرف خاطئًا.",
    "catalogue": "سعر الكتالوج: {{price}}",
    "resetPrice": "استخدام سعر الكتالوج",
    "discount": "خصم السطر",
    "discountType": "نوع الخصم",
    "discountPercent": "%",
    "discountLine": "على السطر",
    "discountUnit": "لكل وحدة",
    "discountValue": "الخصم",
    "saleDiscountSet": "على البيع خصم مستقل. احذفه لتتمكن من خصم سطور منفردة.",
    "lineTotal": "إجمالي السطر",
    "apply": "تطبيق",
    "remove": "حذف السطر"
  },
  "customer": {
    "label": "العميل",
    "title": "عميل هذا البيع",
    "body": "اختر عميلًا مسجلًا، أو أبقِ البيع لزبون نقدي.",
    "walkIn": "زبون نقدي",
    "walkInName": "زبون نقدي",
    "change": "العميل",
    "clear": "العودة إلى زبون نقدي",
    "credit": "آجل",
    "creditHint": "يمكنه الشراء على الحساب: يبقى غير المدفوع مستحقًا على الفاتورة."
  },
  "saleDiscount": {
    "label": "خصم على البيع",
    "none": "لا يوجد",
    "add": "إضافة",
    "edit": "تغيير",
    "remove": "حذف الخصم",
    "title": "خصم على البيع كاملًا",
    "body": "يُوزَّع على الأصناف قبل الضريبة، ولا يُجمع مع خصومات السطور.",
    "type": "نوع الخصم",
    "percentage": "نسبة مئوية",
    "amount": "مبلغ",
    "percentValue": "نسبة الخصم",
    "amountValue": "مبلغ الخصم",
    "discountAmount": "الخصم",
    "apply": "تطبيق الخصم",
    "percentOff": "خصم {{value}}%",
    "amountOff": "خصم {{amount}}",
    "lineDiscounts": "على بعض السطور خصومات خاصة بها: احذفها لتخصم البيع كاملًا."
  },
  "loyalty": {
    "label": "النقاط",
    "points_zero": "لا نقاط",
    "points_one": "نقطة واحدة",
    "points_two": "نقطتان",
    "points_few": "{{points}} نقاط",
    "points_many": "{{points}} نقطة",
    "points_other": "{{points}} نقطة",
    "chip": "نقاط الولاء",
    "owes": "مستحق عليه {{points}}",
    "notMember": "ليس عضوًا",
    "blocked": "موقوف",
    "worth": "قيمتها {{amount}}",
    "redeem": "استبدال",
    "change": "تغيير",
    "remove": "إزالة النقاط",
    "title": "استبدال النقاط",
    "body": "تُخصم النقاط من البيع قبل ضريبة القيمة المضافة.",
    "balance": "المتاح",
    "rate": "القيمة",
    "rateValue": "{{points}} = {{amount}}",
    "most": "الحد الأقصى لهذا البيع",
    "field": "النقاط المستبدلة",
    "useMax": "الحد الأقصى",
    "off": "خصم النقاط",
    "before": "قبل النقاط",
    "apply": "تطبيق النقاط",
    "reduced": "خُفّضت إلى {{points}}، وهو أقصى ما يسمح به هذا البيع.",
    "enterPoints": "أدخل عدد النقاط المراد استبدالها.",
    "minPoints": "استبدل {{points}} على الأقل.",
    "cannot": "لا يمكن استبدال نقاط في هذا البيع",
    "blocks": {
      "PROGRAM_OFF": "برنامج الولاء متوقف.",
      "NOT_MEMBER": "هذا العميل ليس عضوًا في برنامج الولاء.",
      "MEMBER_BLOCKED": "هذا العضو موقوف عن استبدال النقاط.",
      "DISCOUNT_CONFLICT": "لا يمكن الجمع بين النقاط وخصم على البيع كاملًا.",
      "BELOW_MIN_SALE": "تُستبدل النقاط فقط في المبيعات التي لا تقل عن {{amount}}.",
      "BELOW_MIN_POINTS": "أقصى ما يسمح به هذا البيع أقل من الحد الأدنى للاستبدال ({{points}}).",
      "NO_BALANCE": "لا توجد نقاط كافية للاستبدال."
    },
    "notice": {
      "lowered": "أصبح البيع يسمح بـ {{points}} على الأكثر، فخُفّضت النقاط إلى ذلك.",
      "removed": "أُزيلت النقاط من البيع. {{reason}}",
      "changed": "تغيّرت نقاط العميل أو البرنامج: يأخذ البيع الآن {{points}} (خصم {{amount}}). راجع الإجمالي الجديد مع العميل ثم استلم الدفع من جديد.",
      "changedRemoved": "تغيّرت نقاط العميل أو البرنامج، فلن تُخصم نقاط من هذا البيع الآن. راجع الإجمالي الجديد مع العميل ثم استلم الدفع من جديد."
    },
    "receipt": {
      "label": "نقاط الولاء",
      "redeemed": "النقاط المستبدلة",
      "released": "النقاط المُعادة",
      "earned": "النقاط المكتسبة",
      "toEarn": "نقاط تُكتسب عند السداد",
      "availableOn": "قابلة للاستبدال من {{date}}",
      "balance": "رصيد النقاط"
    }
  },
  "totals": {
    "label": "الإجماليات",
    "items": "عدد القطع",
    "subtotal": "المجموع",
    "discount": "الخصم",
    "vat": "ضريبة القيمة المضافة",
    "vatIncluded": "الضريبة المضمّنة",
    "total": "الإجمالي",
    "beforeDiscount": "قبل الخصم",
    "points": "النقاط ({{points}})"
  },
  "pay": {
    "button": "الدفع",
    "title": "استلام الدفع",
    "total": "المطلوب",
    "method": "طريقة الدفع",
    "cash": "نقدًا",
    "card": "بطاقة",
    "split": "دفع مجزأ",
    "received": "النقد المستلم",
    "receivedHint": "اتركه فارغًا إذا دفع العميل المبلغ بالضبط.",
    "quickCash": "مبالغ نقدية سريعة",
    "exact": "المبلغ بالضبط",
    "change": "الباقي",
    "cardWhole": "يُدفع المبلغ كاملًا بالبطاقة.",
    "reference": "مرجع إيصال البطاقة",
    "referenceHint": "اختياري: رقم الموافقة أو الإيصال.",
    "cardPart": "المدفوع بالبطاقة",
    "cashPart": "المدفوع نقدًا",
    "complete": "إتمام البيع",
    "nothingDue": "لا شيء للدفع: قيمة البيع صفر.",
    "cashShort": "النقد المستلم أقل من المبلغ المطلوب {{amount}}.",
    "cardMissing": "أدخل المبلغ المدفوع بالبطاقة.",
    "cardOverTotal": "المبلغ المدفوع بالبطاقة أكبر من الإجمالي.",
    "changeTooLarge": "يبدو هذا المبلغ خاطئًا: سيكون الباقي {{largest}} أو أكثر. هل مُسح باركود فيه؟ صحّح النقد المستلم.",
    "scanIgnored": "مُسح باركود في خانة النقد المستلم فتم تجاهله. امسح الأصناف في البيع، لا هنا.",
    "cashOnlyTitle": "هذا الصندوق يقبل النقد فقط",
    "cashOnly": "لا يوجد له حساب بطاقات. استلم المبلغ نقدًا، أو اطلب من المدير إضافة حساب بطاقات للصندوق.",
    "badQuantity": "يجب أن تكون كمية كل سطر أكبر من صفر.",
    "serialsMissing": "اختر رقمًا تسلسليًا لكل وحدة مبيعة من {{name}} (ر.ت في سطره) قبل استلام المبلغ.",
    "methodWhole": "يُدفع المبلغ كاملًا عبر {{name}}.",
    "methodPart": "المدفوع عبر {{name}}",
    "splitMethod": "الجزء غير النقدي عبر",
    "chargeToAccount": "تحميل على الحساب",
    "onAccount": "على حساب {{name}}",
    "onAccountHint": "إتمام البيع يتطلب الدفع كاملًا. أما التحميل على الحساب فيأخذ ما أُدخل ويُبقي الباقي مستحقًا على الفاتورة."
  },
  "receipt": {
    "label": "إيصال {{number}}",
    "taxInvoice": "فاتورة ضريبية",
    "vatNumber": "الرقم الضريبي",
    "crNumber": "السجل التجاري",
    "phone": "هاتف",
    "invoiceNumber": "الفاتورة",
    "date": "التاريخ",
    "till": "الصندوق",
    "cashier": "الكاشير",
    "customer": "العميل",
    "items": "الأصناف",
    "discount": "خصم",
    "discountOf": "خصم {{discount}}",
    "totalDiscount": "إجمالي الخصم",
    "vatOn": "ضريبة {{rate}} على {{net}}",
    "total": "الإجمالي",
    "vatIncluded": "الأسعار شاملة الضريبة.",
    "cashTendered": "النقد المستلم",
    "change": "الباقي",
    "voidReason": "مُبطَل: {{reason}}",
    "thanks": "شكرًا لتسوقكم معنا",
    "currency": "المبالغ بالريال العُماني (<rial/>).",
    "done": "تم البيع",
    "voided": "أُبطِل البيع",
    "changeDue": "الباقي للعميل",
    "print": "طباعة الإيصال",
    "newSale": "بيع جديد",
    "onAccount": "على الحساب",
    "stillDue": "المتبقي على {{name}}",
    "nextHint": "مسح الصنف التالي يبدأ بيعًا جديدًا."
  },
  "return": {
    "title": "إرجاع بضاعة",
    "body": "ابحث عن البيع برقم الفاتورة المطبوع على الإيصال.",
    "invoiceNumber": "رقم الفاتورة",
    "find": "بحث عن البيع",
    "notFound": "لا يوجد بيع من نقطة البيع برقم الفاتورة «{{number}}».",
    "candidates": "المبيعات المطابقة",
    "saleTotal": "إجمالي البيع",
    "lines": "أصناف البيع",
    "sold": "المباع",
    "returned": "المرتجع",
    "remaining": "المتبقي",
    "quantity": "الإرجاع",
    "quantityOf": "كمية {{name}} المرتجعة",
    "refund": "المبلغ المسترد",
    "all": "إرجاع كل المتبقي",
    "refundTotal": "المبلغ المسترد",
    "method": "طريقة الاسترداد",
    "storeCredit": "رصيد للعميل",
    "cashHint": "يُدفع من درج هذا الصندوق.",
    "cardHint": "يُعاد إلى البطاقة التي دُفع بها البيع.",
    "cardLeft": "ما يزال يمكن ردّه إلى البطاقة:",
    "cardCap": "لا يمكن أن يُعاد إلى البطاقة التي دُفع بها هذا البيع أكثر من {{amount}}. أرجِع أصنافًا أقل إلى البطاقة، أو استرد المبلغ بطريقة أخرى.",
    "cashCap": "لا يمكن أن يُردّ نقدًا من هذا البيع أكثر من {{amount}}، وهو ما دُفع نقدًا ولم يُردّ بعد. ويحتاج ردّ مبلغ أكبر إلى مشرف مخوَّل بالاسترداد أيًّا كانت طريقة الدفع.",
    "settlesBalance": "{{amount}} من هذا المرتجع يخفّض ما يزال على {{customer}} من هذا البيع، ولا يُردّ إلا الباقي.",
    "cashCapNone": "لم يتبقَّ من النقد المدفوع في هذا البيع شيء يُردّ، لذا يحتاج الاسترداد النقدي إلى مشرف مخوَّل بالاسترداد أيًّا كانت طريقة الدفع.",
    "creditHint": "يحتفظ {{customer}} به رصيدًا لمشتريات لاحقة.",
    "creditNeedsSales": "الرصيد لدى المتجر يتطلب وحدة المبيعات، وهي متوقفة لشركتك.",
    "reason": "السبب",
    "chooseLines": "أدخل عدد القطع المرتجعة من كل صنف.",
    "nothingLeft": "أُرجع كل ما في هذا البيع من قبل.",
    "serialsMissing": "اختر الرقم التسلسلي لكل وحدة مرتجعة من {{name}} (ر.ت في سطره).",
    "otherSale": "بيع آخر",
    "submit": {
      "CASH": "استرداد {{amount}} نقدًا",
      "CARD": "استرداد {{amount}} إلى البطاقة",
      "STORE_CREDIT": "الاحتفاظ بـ {{amount}} رصيدًا"
    },
    "submitBalance": "تخفيض المبلغ المستحق بمقدار {{amount}}",
    "confirmTitle": "تسجيل هذا الإرجاع؟",
    "confirm": {
      "CASH": "سيُدفع للعميل {{amount}} من الدرج.",
      "CARD": "سيُسترد {{amount}} إلى بطاقة العميل.",
      "STORE_CREDIT": "سيحتفظ {{customer}} بمبلغ {{amount}} رصيدًا لدى المتجر."
    },
    "confirmBalance": "لن يُردّ أي مبلغ: يُخصم {{amount}} مما يزال على {{customer}} من هذا البيع.",
    "done": {
      "CASH": "سُجّل الإرجاع {{number}}: ادفع {{amount}} نقدًا.",
      "CARD": "سُجّل الإرجاع {{number}}: استُرد {{amount}} إلى البطاقة.",
      "STORE_CREDIT": "سُجّل الإرجاع {{number}}: احتُفظ بـ {{amount}} رصيدًا للعميل."
    },
    "doneBalance": "سُجّل الإرجاع {{number}}: خُصم {{amount}} مما على {{customer}}، ولم يُردّ أي مبلغ."
  },
  "unlinked": {
    "action": "إرجاع بدون إيصال",
    "actionHint": "لا يوجد بيع على الصندوق: اشتُري قبل الصندوق أو بفاتورة، أو فُقد الإيصال.",
    "body": "البضاعة التي لا بيع على الصندوق خلفها تعود إلى مستودع هذا الصندوق بسعر اليوم.",
    "back": "البحث عن بيع بدلًا من ذلك",
    "add": "الصنف المُرجَع",
    "addPlaceholder": "امسح الصنف أو ابحث عنه",
    "lines": "الأصناف المُرجَعة",
    "empty": "أضف الأصناف التي يعيدها العميل.",
    "unitPrice": "سعر الوحدة",
    "actions": "إجراءات",
    "quantityOf": "كمية {{name}} المُرجَعة",
    "priceOf": "سعر وحدة {{name}}",
    "remove": "إزالة {{name}}",
    "priceCap": "يمكن خفض السعر، لا رفعه فوق سعر البيع اليوم.",
    "cardHint": "إلى حساب البطاقات لهذا الصندوق."
  },
  "returnReceipt": {
    "label": "إيصال إرجاع {{number}}",
    "title": "إشعار دائن ضريبي",
    "stamp": "مرتجع",
    "creditNote": "الإشعار الدائن",
    "invoice": "الفاتورة الأصلية",
    "noSale": "بدون بيع على الصندوق",
    "total": "إجمالي المُرتجَع",
    "method": {
      "CASH": "دُفع نقدًا",
      "CARD": "رُدّ إلى البطاقة",
      "STORE_CREDIT": "رصيد دائن للعميل"
    },
    "toCard": "رُدّ إلى {{method}}",
    "refundNumber": "رقم الاسترداد",
    "reason": "السبب: {{reason}}"
  },
  "returnPanel": {
    "done": "سُجّل الإرجاع",
    "payOut": "ادفع للعميل",
    "print": "طباعة إيصال الإرجاع"
  },
  "rules": {
    "pricesLoading": "جارٍ تحميل أسعار هذا العميل. استلم الدفع بعد لحظات.",
    "pricesChanged": "تغيّرت الأسعار منذ مسح هذه الأصناف: {{names}}. راجع الإجمالي الجديد مع العميل ثم استلم الدفع من جديد.",
    "pricesChangedReturn": "تغيّرت أسعار اليوم: {{names}}. راجع المبلغ المسترد مع العميل ثم سجّل الإرجاع من جديد.",
    "lineProblem": "{{name}}: {{message}}",
    "lineMarked": "راجع هذا السطر",
    "notSoldInUnit": "لم يعد هذا الصنف يُباع بهذه الوحدة.",
    "unitQuantity": {
      "WHOLE_UNITS": "هذه الوحدة لا تقبل الكسور.",
      "WHOLE_BASE_UNITS": "هذه الكمية تعطي جزءًا من الوحدة الأساسية، والوحدة الأساسية لا تقبل الكسور.",
      "BASE_SCALE": "هذه الكمية تعطي أكثر من أربع منازل عشرية من الوحدة الأساسية."
    },
    "returnQuantityOfPack": "كمية {{name}} ({{pack}}) المرتجعة",
    "loyalty": {
      "redeemed": "النقاط المستبدلة في البيع",
      "released": "النقاط المُعادة عن المرتجعات",
      "earnsNow": "النقاط التي يكسبها البيع الآن",
      "toEarnNow": "النقاط التي يكسبها البيع عند السداد"
    }
  },
  "shiftReturns": {
    "title": "المرتجعات",
    "empty": "لا توجد مرتجعات في هذه الوردية.",
    "creditNote": "الإشعار الدائن",
    "sale": "البيع",
    "method": "الاسترداد",
    "amount": "المبلغ",
    "methods": {
      "CASH": "نقدًا",
      "CARD": "بطاقة",
      "STORE_CREDIT": "رصيد دائن"
    },
    "reprintNamed": "إعادة طباعة إيصال إرجاع {{number}}",
    "openNamed": "فتح الإرجاع {{number}}"
  },
  "returnPage": {
    "summary": "الإرجاع"
  },
  "cash": {
    "title": "إيداع / سحب نقدي",
    "body": "نقل النقد بين درج هذا الصندوق والخزنة أو البنك.",
    "direction": "الاتجاه",
    "out": "سحب",
    "in": "إيداع",
    "outHint": "يخرج النقد من الدرج، مثل الإيداع في البنك.",
    "inHint": "يدخل النقد إلى الدرج، مثل تعزيز الرصيد من الخزنة.",
    "from": "من",
    "to": "إلى",
    "account": "الحساب",
    "amount": "المبلغ",
    "reason": "السبب",
    "transfer": "التحويل",
    "submitOut": "سحب",
    "submitIn": "إيداع",
    "doneOut": "سُحب {{amount}} من الدرج.",
    "doneIn": "أُودع {{amount}} في الدرج."
  },
  "movement": {
    "in": "إيداع",
    "out": "سحب"
  },
  "sales": {
    "title": "المبيعات",
    "titleOf": "مبيعات الوردية {{number}}",
    "empty": "لا مبيعات في هذه الوردية بعد.",
    "time": "الوقت",
    "invoice": "الفاتورة",
    "customer": "العميل",
    "total": "الإجمالي",
    "status": "الحالة",
    "actions": "الإجراءات",
    "reprint": "إعادة الطباعة",
    "reprintNamed": "إعادة طباعة إيصال {{number}}",
    "open": "الإيصال",
    "openNamed": "فتح البيع {{number}}"
  },
  "void": {
    "action": "إبطال",
    "named": "إبطال البيع {{number}}",
    "title": "إبطال البيع {{number}}؟",
    "body": "تُعكس دفعاته وفاتورته وتعود البضاعة إلى المخزون. لا يمكن إبطال بيع عليه مرتجعات.",
    "confirm": "إبطال البيع",
    "done": "أُبطِل البيع {{number}}."
  },
  "clear": {
    "title": "مسح هذا البيع؟",
    "body": "تُحذف كل الأصناف والعميل والخصم.",
    "confirm": "مسح البيع"
  },
  "close": {
    "title": "إغلاق الوردية {{number}}",
    "body": "عُدّ كل ورقة نقدية وعملة معدنية في الدرج.",
    "pendingSale": "البيع الظاهر على الشاشة لم يُدفع بعد، وسيُلغى عند إغلاق الوردية.",
    "count": "عدّ الدرج",
    "value": "الفئة",
    "countHeader": "العدد",
    "amount": "المبلغ",
    "countOf": "عدد فئة {{value}}",
    "counted": "المعدود",
    "expected": "المتوقع",
    "variance": "الفرق",
    "blindTitle": "إغلاق دون عرض المتوقع",
    "blind": "عُدّ ما في الدرج. يظهر المبلغ المتوقع وأي فرق في تقرير Z.",
    "notes": "ملاحظات",
    "notesHint": "اختياري: ما يلزم أن يعرفه المشرف.",
    "keys": "ينتقل Enter إلى الفئة التالية.",
    "submit": "إغلاق الوردية",
    "confirmTitle": "إغلاق الوردية {{number}}؟",
    "confirmBody": "عدّ الدرج البالغ {{amount}} نهائي، ولا يمكن البيع على هذه الوردية بعده."
  },
  "closed": {
    "title": "أُغلقت الوردية {{number}}",
    "body": "اطبع تقرير Z لكيس النقد، ثم افتح وردية جديدة أو عُد إلى الإدارة.",
    "print": "طباعة تقرير Z",
    "openNew": "فتح وردية جديدة"
  },
  "report": {
    "x": "تقرير X",
    "z": "تقرير Z",
    "xTitle": "تقرير X للوردية {{number}}",
    "zTitle": "تقرير Z للوردية {{number}}",
    "xNote": "الأرقام حتى الآن؛ الوردية ما زالت مفتوحة.",
    "till": "الصندوق",
    "cashier": "الكاشير",
    "opened": "الفتح",
    "closed": "الإغلاق",
    "closedBy": "أغلقها",
    "sales": "المبيعات",
    "salesCount": "المبيعات ({{count}})",
    "discounts": "الخصومات",
    "vat": "ضريبة القيمة المضافة",
    "voided": "المُبطَلة ({{count}})",
    "tenders": "المدفوعات",
    "cash": "نقدًا",
    "card": "بطاقة",
    "bankTransfer": "تحويل بنكي",
    "other": "أخرى",
    "returns": "المرتجعات",
    "returnsCount": "المرتجعات ({{count}})",
    "cashRefunds": "استردادات نقدية",
    "cardRefunds": "استردادات بالبطاقة",
    "storeCredit": "رصيد للعملاء",
    "drawer": "الدرج",
    "openingFloat": "رصيد الافتتاح",
    "cashSales": "مبيعات نقدية",
    "payIns": "الإيداعات",
    "payOuts": "المسحوبات",
    "expected": "النقد المتوقع",
    "counted": "النقد المعدود",
    "variance": "الفرق",
    "denominations": "العدّ",
    "movements": "الإيداعات والمسحوبات",
    "generated": "طُبع في {{time}}",
    "backToSale": "العودة إلى البيع",
    "byMethod": "حسب طريقة الدفع",
    "methodCount": "{{name}} ({{count}})"
  },
  "variance": {
    "surplus": "زيادة",
    "shortage": "عجز",
    "balanced": "مطابق"
  },
  "shiftStatus": {
    "OPEN": "مفتوحة",
    "CLOSED": "مغلقة"
  },
  "saleStatus": {
    "COMPLETED": "مكتمل",
    "VOID": "مُبطَل"
  },
  "shifts": {
    "title": "الورديات",
    "subtitle": "ورديات الصناديق مع عدّ الدرج والفروقات.",
    "statusFilter": "الحالة",
    "allStatuses": "كل الحالات",
    "tillFilter": "الصندوق",
    "allTills": "كل الصناديق",
    "empty": "لا ورديات بعد",
    "emptyBody": "تظهر الورديات هنا عندما يفتحها الكاشير في نقطة البيع.",
    "fields": {
      "number": "الوردية",
      "till": "الصندوق",
      "cashier": "الكاشير",
      "opened": "الفتح",
      "closed": "الإغلاق",
      "float": "رصيد الافتتاح",
      "expected": "المتوقع",
      "counted": "المعدود",
      "variance": "الفرق",
      "status": "الحالة"
    },
    "stats": {
      "label": "أرقام الورديات",
      "open": "المفتوحة الآن",
      "openDetail": "العُهد {{float}}",
      "netSales": "صافي مبيعات نقاط البيع",
      "netSalesDetail": "{{month}} · بعد المرتجعات",
      "trend": "صافي مبيعات نقاط البيع حسب الشهر، من {{from}} إلى {{to}}",
      "short": "العجز النقدي",
      "shortDetail": "{{month}} · {{shifts}} · زيادة {{over}}",
      "closed": "المغلقة",
      "closedDetail": "تم عدّها وإغلاقها",
      "shifts_zero": "لا ورديات بعجز",
      "shifts_one": "وردية واحدة بعجز",
      "shifts_two": "ورديتان بعجز",
      "shifts_few": "{{n}} ورديات بعجز",
      "shifts_many": "{{n}} وردية بعجز",
      "shifts_other": "{{n}} وردية بعجز"
    }
  },
  "shift": {
    "summary": "الوردية",
    "notes": "ملاحظات",
    "printX": "طباعة تقرير X",
    "printZ": "طباعة تقرير Z",
    "noMovements": "لا إيداعات ولا مسحوبات في هذه الوردية."
  },
  "sale": {
    "subtitle": "الصندوق {{till}} · {{time}}",
    "summary": "البيع",
    "invoice": "الفاتورة",
    "shift": "الوردية",
    "tenders": "المدفوعات",
    "voidTitle": "أُبطِل هذا البيع",
    "voidReason": "السبب: {{reason}}",
    "noVoid": {
      "title": "لم يعد إبطال هذا البيع ممكنًا",
      "closed": "أُغلقت ورديته.",
      "returned": "أُرجعت بضاعة منه.",
      "otherShift": "هو من وردية كاشير آخر، ويستطيع مدير الورديات إبطاله."
    }
  },
  "tills": {
    "title": "الصناديق",
    "subtitle": "يبيع كل صندوق من مستودع واحد، ويحفظ النقد في درجه، ويستلم دفعات البطاقات في حساب البطاقات.",
    "new": "صندوق جديد",
    "newTitle": "صندوق جديد",
    "newSubtitle": "صندوق لنقطة البيع.",
    "editTitle": "تعديل الصندوق",
    "editNamed": "تعديل الصندوق {{code}}",
    "save": "حفظ الصندوق",
    "actions": "الإجراءات",
    "active": "قيد الاستخدام",
    "inactive": "غير مستخدم",
    "activeLabel": "قيد الاستخدام",
    "cashOnly": "نقدًا فقط",
    "noCard": "لا يوجد (نقدًا فقط)",
    "choose": "اختر…",
    "empty": "لا صناديق بعد",
    "emptyBody": "أضف صندوقًا لتبدأ البيع في نقطة البيع.",
    "openShiftNote": "الورديات المفتوحة على هذا الصندوق: {{count}}. يبقى قيد الاستخدام ويحتفظ بدرجه حتى تُغلق.",
    "sharedDrawer": "يستخدم الصندوق {{tills}} هذا الدرج أيضًا: لا تُفتح في الوقت نفسه إلا وردية واحدة على صناديق الدرج الواحد.",
    "officeCash": "نقدية المكتب أيضًا",
    "officeCashNote": "هذا الدرج هو أيضًا حساب نقدية المكتب. إيصالات المكتب ومدفوعاته ومصروفاته تغيّر ما يتوقع الصندوق عدّه، لذا لا يمكنها استخدامه الآن. خصّص للصندوق درجًا خاصًا به ليعود حساب النقدية إلى المكتب.",
    "ownDrawer": {
      "action": "خصّص لهذا الصندوق درجًا خاصًا",
      "hint": "يصبح حساب نقدي جديد هو الدرج، فلا يحرّك المال فيه إلا الصندوق.",
      "openShift": "أغلق الوردية المفتوحة على هذا الصندوق أولًا.",
      "title": "تخصيص درج خاص للصندوق {{code}}",
      "body": "يصبح حساب نقدي جديد باسم {{name}} درجَ هذا الصندوق، ويبقى {{old}} للمكتب.",
      "accountName": "درج نقطة البيع {{code}}",
      "cash": "النقد الموجود في الدرج الآن",
      "cashHint": "عُدّ الدرج: ينتقل هذا المبلغ من {{old}} إلى الدرج الجديد. أدخل 0 إذا كان فارغًا.",
      "submit": "خصّص الدرج",
      "toast": "أصبح للصندوق {{code}} درج خاص به: {{name}}.",
      "nameTaken": "يوجد حساب نقدية أو بنك باسم {{name}}. اختره درجًا للصندوق من نموذج الصندوق، أو غيّر اسمه أولًا."
    },
    "fields": {
      "code": "الرمز",
      "name": "الاسم",
      "nameAr": "الاسم (عربي)",
      "warehouse": "المستودع",
      "drawer": "الدرج (حساب نقدي)",
      "card": "حساب البطاقات",
      "openShifts": "الورديات المفتوحة",
      "status": "الحالة"
    },
    "hints": {
      "code": "حتى 32 حرفًا أو رقمًا أو شرطة، مثل TILL-01.",
      "warehouse": "تُصرف منه بضاعة مبيعات هذا الصندوق.",
      "drawer": "الحساب النقدي لدرج هذا الصندوق.",
      "card": "جهاز بطاقات أو حساب بنكي؛ بدونه يقبل الصندوق النقد فقط.",
      "active": "لا يمكن فتح ورديات على صندوق غير مستخدم."
    },
    "toast": {
      "created": "أُضيف الصندوق {{code}}.",
      "updated": "حُفظ الصندوق {{code}}."
    },
    "errors": {
      "codeTaken": "هذا الرمز مستخدم لصندوق آخر.",
      "version": "عدّل شخص آخر هذا الصندوق. أغلقه وافتحه مرة أخرى لترى آخر نسخة."
    }
  },
  "errors": {
    "INSUFFICIENT_STOCK": "المخزون لا يكفي لهذا البيع. تمنع سياسة المخزون المبيعات التي تُنزل المخزون إلى ما دون الصفر: احذف هذه الأصناف أو خفّض كمياتها، ثم استلم المبلغ من جديد.",
    "stockInventoryOff": "وحدة المخزون متوقفة لشركتك، فلا يمكن تحويل المخزون أو جرده. يمكن للمدير تغيير سياسة المخزون في الإعدادات › المخزون.",
    "CASH_ONLY_TILL": "هذا الصندوق يقبل النقد فقط. استلم المبلغ نقدًا.",
    "CREDIT_NOT_ALLOWED": "لا يمكن لهذا العميل الشراء على الحساب في نقطة البيع. خذ المبلغ كاملًا.",
    "TILL_CREDIT_NEEDS_SALES": "البيع على الحساب يتطلب وحدة المبيعات، وهي متوقفة لشركتك. خذ المبلغ كاملًا.",
    "TENDER_MISMATCH": "مجموع المدفوعات لا يساوي إجمالي البيع.",
    "TENDER_EXCEEDS_DUE": "دفعة البطاقة أكبر من المبلغ المتبقي.",
    "DISCOUNT_CONFLICT": "لا يمكن جمع خصم على البيع كاملًا مع خصومات السطور. احذفها أولًا.",
    "SHIFT_CLOSED": "هذه الوردية مغلقة. افتح وردية جديدة لمتابعة البيع.",
    "SHIFT_NOT_YOURS": "هذه الوردية لكاشير آخر.",
    "SALE_HAS_RETURNS": "أُرجعت بضاعة من هذا البيع، فلم يعد إبطاله ممكنًا.",
    "SALE_CREDITED": "صدر إشعار دائن على هذا البيع من الإدارة، فلم يعد إبطاله ممكنًا.",
    "SALE_VOID": "أُبطِل هذا البيع؛ لا يمكن إرجاع شيء منه.",
    "NO_CARD_PAYMENT": "لم يُدفع هذا البيع بالبطاقة. استرد المبلغ نقدًا.",
    "WALK_IN_NO_CREDIT": "يسترد الزبون النقدي المبلغ فورًا؛ الرصيد لدى المتجر يتطلب عميلًا مسجلًا.",
    "STORE_CREDIT_NEEDS_SALES": "الرصيد لدى المتجر يتطلب وحدة المبيعات، وهي متوقفة لشركتك. ردّ المبلغ نقدًا أو بالبطاقة.",
    "TERMINAL_INACTIVE": "هذا الصندوق غير مستخدم. اختر صندوقًا آخر أو راجع المدير.",
    "TERMINAL_HAS_OPEN_SHIFT": "توجد وردية مفتوحة على هذا الصندوق. أغلقها قبل إيقاف الصندوق أو تغيير درجه.",
    "DRAWER_IN_USE": "توجد وردية مفتوحة على صندوق آخر يستخدم الدرج نفسه. أغلق تلك الوردية قبل فتح وردية هنا.",
    "DRAWER_ARCHIVED": "حساب درج هذا الصندوق مؤرشف. يجب أن يختار المدير درجًا آخر للصندوق أولًا.",
    "TILL_WAREHOUSE_ARCHIVED": "مستودع هذا الصندوق مؤرشف. يجب أن يختار المدير مستودعًا آخر للصندوق أولًا.",
    "DRAWER_NOT_CASH": "حساب درج هذا الصندوق لم يعد حساب نقدية. يجب أن يختار المدير درجًا آخر للصندوق أولًا.",
    "TILL_CARD_ACCOUNT_UNUSABLE": "حساب البطاقات لهذا الصندوق مؤرشف أو لم يعد حساب جهاز بطاقات أو حسابًا بنكيًا. استخدم النقد بدلًا من البطاقة، أو اطلب من المدير أن يختار حساب بطاقات آخر للصندوق.",
    "REFUND_ACCOUNT_UNUSABLE": "الحساب الذي أُودعت فيه دفعة البطاقة لهذا البيع مؤرشف أو أصبح حسابًا نقديًا، فلا يمكن رد المبلغ إليه بالبطاقة. استرد المبلغ نقدًا (ما يزيد على النقد المدفوع في البيع يحتاج إلى مشرف)، أو احتفظ به رصيدًا للعميل.",
    "CARD_REFUND_EXCEEDS_CARD": "لا يمكن أن يُعاد من هذا البيع إلى البطاقة التي دُفع بها أكثر من {{amount}}. أرجِع أصنافًا أقل إلى البطاقة واسترد الباقي نقدًا، أو احتفظ به رصيدًا للعميل.",
    "REFUND_TENDER_NEEDS_OVERRIDE": "لا يمكن أن يُردّ نقدًا من هذا البيع أكثر من {{amount}}، وهو ما دُفع نقدًا ولم يُردّ بعد. استرد المبلغ بالطريقة التي دُفع بها البيع، أو اطلب ذلك من مشرف مخوَّل بالاسترداد أيًّا كانت طريقة الدفع.",
    "methodIntoCash": "تذهب طريقة الدفع هذه إلى حساب نقدية، فلا يمكن للصندوق قبولها. استلم بطريقة دفع أخرى، أو اطلب من المدير أن يجعل للطريقة حساب جهاز بطاقات أو بنك أو محفظة.",
    "RETURN_EXCEEDS_SOLD": "الكمية أكبر مما تبقى للإرجاع من البيع.",
    "INSUFFICIENT_FUNDS": "الحساب الذي يخرج منه النقد لا يحتوي هذا المبلغ اليوم. خفّض المبلغ أو اختر حسابًا آخر.",
    "WHOLE_UNITS_ONLY": "هذا الصنف يُعدّ بوحدات كاملة.",
    "SERIAL_COUNT_MISMATCH": "الصنف المتتبَّع بالأرقام التسلسلية يحتاج رقمًا تسلسليًا لكل وحدة. راجع الأرقام في السطر المُعلَّم.",
    "SERIAL_NOT_AVAILABLE": "لم تعد متوفرة في مخزون هذا الصندوق: {{serials}}. اختر أرقامًا تسلسلية أخرى في السطر المُعلَّم.",
    "SERIAL_NOT_SOLD": "لم تُبع في هذا السطر من البيع، أو أُرجعت من قبل: {{serials}}.",
    "SERIAL_TAKEN": "موجود في المخزون أو مُباع أو مكرر: {{serials}}. الرقم التسلسلي المُباع لا يعود إلا بإرجاع بيعه.",
    "SERIAL_DUPLICATE": "رقم تسلسلي مُدرج أكثر من مرة: {{serials}}.",
    "SERIALS_NOT_TRACKED": "الصنف المُعلَّم لم يعد يتتبع الأرقام التسلسلية. احذفه وامسحه من جديد.",
    "SERIAL_MOVED_ON": "رقم تسلسلي من هذا البيع انتقل منذ ذلك الحين (بيع مجددًا أو أُرجع أو حُوِّل): {{serials}}.",
    "priceOverride": "تغيير الأسعار أو منح الخصومات يتطلب صلاحية تعديل الأسعار.",
    "alreadyOpen": "توجد وردية مفتوحة على هذا الصندوق. أغلقها قبل فتح وردية أخرى.",
    "LOYALTY_REDEMPTION_CHANGED": "تغيّر ما يمكن أن يأخذه هذا البيع من النقاط (رصيد العميل أو البيع أو البرنامج). راجع النقاط والإجمالي الجديد ثم استلم الدفع من جديد.",
    "LOYALTY_BALANCE_CHANGED": "تغيّر رصيد نقاط العميل في هذه الأثناء (استُخدمت نقاط في مكان آخر). راجع النقاط والإجمالي الجديد ثم استلم الدفع من جديد."
  },
  "salesperson": {
    "label": "مندوب المبيعات",
    "default": "مندوب مبيعات العميل، وإلا فأنت",
    "none": "بلا مندوب",
    "change": "تغيير",
    "changeLabel": "تغيير مندوب المبيعات",
    "title": "مندوب مبيعات هذا البيع",
    "body": "من يُنسب إليه هذا البيع في احتساب العمولة.",
    "useDefault": "مندوب العميل أو أنا",
    "me": "أنا"
  }
}
